"use strict";

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dateFns = _interopRequireDefault(require("date-fns"));

var INCOME_TYPES = _interopRequireWildcard(require("./types"));

var INCOME_SUB_TYPES = _interopRequireWildcard(require("./subTypes"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function calcIncomeSummarySlice() {
  var incs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var startAt = arguments.length > 1 ? arguments[1] : undefined;
  var endAt = arguments.length > 2 ? arguments[2] : undefined;
  var sum = {
    startAt: startAt,
    endAt: endAt === 'year' ? _dateFns["default"].addMonths(startAt, 12) : endAt,
    numMonths: _dateFns["default"].differenceInMonths(endAt === 'year' ? _dateFns["default"].addMonths(startAt, 12) : endAt, startAt),
    year: endAt === 'year' ? _dateFns["default"].getYear(startAt) : null,
    // Employment (SOFA Q.4)
    valueIncome: 0,
    valueCommission: 0,
    valueOvertime: 0,
    valueBusiness: 0,
    valueGrossIncome: 0,
    // Other Income (SOFA Q.5)
    valueOther: 0,
    otherIncomes: [],
    // Means Test
    valueAlimonyMaintenance: 0,
    valueContributionsSupport: 0,
    valueBusinessGross: 0,
    valueBusinessExpenses: 0,
    valueBusinessNetIncome: 0,
    valuePropertyGross: 0,
    valuePropertyExpenses: 0,
    valuePropertyNetIncome: 0,
    valueInterestDividendsRoyalties: 0,
    valueUnemployment: 0,
    valueSocialSecurity: 0,
    valuePensionRetirement: 0,
    valueOtherIncome: 0,
    valueTotalMonthlyIncome: 0,
    // Extras - Histograph
    byMonth: {}
  };
  incs.reduce(function (accum, income) {
    return income.disbursements && income.disbursements.length > 0 ? accum.concat(income.disbursements.map(function (pa) {
      return _objectSpread({}, pa, {
        income: income
      });
    })) : accum;
  }, []).filter(function (pa) {
    return _dateFns["default"].isWithinRange(new Date(pa.receivedAt), sum.startAt, sum.endAt);
  }).forEach(function (pa) {
    var receivedAt = new Date(pa.receivedAt); // Cycle to see if our pa advice fits a time bucket

    for (var c = 0; c < sum.numMonths; c += 1) {
      // If Pay Advice isn't in our time bracket, bounce
      if (_dateFns["default"].isPast(receivedAt) && _dateFns["default"].isWithinRange(receivedAt, _dateFns["default"].addMonths(startAt, c), _dateFns["default"].addMonths(startAt, c + 1))) {
        // Set month if doesn't exist
        if (!sum.byMonth[_dateFns["default"].getMonth(receivedAt)]) {
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)] = {
            valueIncome: 0,
            valueCommission: 0,
            valueOvertime: 0,
            valueBusiness: 0,
            valueOther: 0
          };
        } // SOFA Q.4


        if (pa.income.type === INCOME_TYPES.EMPLOYMENT) {
          sum.valueIncome += (sum.numMonths ? Number(pa.valueIncome) / sum.numMonths : Number(pa.valueIncome)) || 0;
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueIncome += (sum.numMonths ? Number(pa.valueIncome) / sum.numMonths : Number(pa.valueIncome)) || 0;
          sum.valueCommission += (sum.numMonths ? Number(pa.valueCommission) / sum.numMonths : Number(pa.valueCommission)) || 0;
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueCommission += (sum.numMonths ? Number(pa.valueCommission) / sum.numMonths : Number(pa.valueCommission)) || 0;
          sum.valueOvertime += (sum.numMonths ? Number(pa.valueOvertime) / sum.numMonths : Number(pa.valueOvertime)) || 0;
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueOvertime += (sum.numMonths ? Number(pa.valueOvertime) / sum.numMonths : Number(pa.valueOvertime)) || 0;
          sum.valueGrossIncome += ((sum.numMonths ? Number(pa.valueIncome) / sum.numMonths : Number(pa.valueIncome)) || 0) + ((sum.numMonths ? Number(pa.valueCommission) / sum.numMonths : Number(pa.valueCommission)) || 0) + ((sum.numMonths ? Number(pa.valueOvertime) / sum.numMonths : Number(pa.valueOvertime)) || 0);
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueGrossIncome += ((sum.numMonths ? Number(pa.valueIncome) / sum.numMonths : Number(pa.valueIncome)) || 0) + ((sum.numMonths ? Number(pa.valueCommission) / sum.numMonths : Number(pa.valueCommission)) || 0) + ((sum.numMonths ? Number(pa.valueOvertime) / sum.numMonths : Number(pa.valueOvertime)) || 0); // SOFA Q.4
        } else if (pa.income.subType === INCOME_SUB_TYPES.BUSINESS_PROFESSIONAL_FARM) {
          sum.valueBusiness += Number(pa.valueBusiness) || 0;
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueBusiness += Number(pa.valueBusiness) || 0;
          sum.valueGrossIncome += Number(pa.valueBusiness) || 0;
          sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueGrossIncome += Number(pa.valueBusiness) || 0; // SOFA Q.5
        } else if (pa.income.type === INCOME_TYPES.NON_EMPLOYMENT) {
          (function () {
            sum.valueOther += Number(pa.value) || 0;
            sum.byMonth[_dateFns["default"].getMonth(receivedAt)].valueOther += Number(pa.value) || 0;
            var newInc = {
              incomeId: pa.income.id,
              name: pa.additionalDescription || pa.otherGovAssistanceName || (pa.income.subType ? pa.income.subType.replace(/_/g, ' ') : null) || 'Other',
              value: sum.numMonths != null ? Number(pa.value) / sum.numMonths : pa.value
            };
            var foundEntry = false;
            sum.otherIncomes = sum.otherIncomes.map(function (oi) {
              if (oi.incomeId === newInc.incomeId) {
                oi.value += sum.numMonths != null ? Number(newInc.value) / sum.numMonths : newInc.value;
                foundEntry = true;
              }

              return oi;
            });
            if (!foundEntry) sum.otherIncomes = sum.otherIncomes.concat(newInc);
          })();
        } // Means Test


        if (pa.income.subType === INCOME_SUB_TYPES.FAMILY_SUPPORT) {
          sum.valueAlimonyMaintenance += Number(pa.value) || 0;
        } else if ([INCOME_SUB_TYPES.HOUSEHOLD_CONTRIBUTIONS, INCOME_SUB_TYPES.OTHER_GOV_ASSISTANCE].includes(pa.income.subType)) {
          sum.valueContributionsSupport += Number(pa.value) || 0;
        } else if (pa.income.subType === INCOME_SUB_TYPES.INTERESTS_DIVIDENDS_ROYALTIES) {
          sum.valueInterestDividendsRoyalties += Number(pa.value) || 0;
        } else if (pa.income.subType === INCOME_SUB_TYPES.PENSION_RETIREMENT) {
          sum.valuePensionRetirement += Number(pa.value) || 0;
        } else if (pa.income.subType === INCOME_SUB_TYPES.UNEMPLOYMENT) {
          sum.valueUnemployment += Number(pa.value) || 0;
        } else if (pa.income.subType === INCOME_SUB_TYPES.SOCIAL_SECURITY) {
          sum.valueSocialSecurity += Number(pa.value) || 0;
        } else if (pa.income.subType === INCOME_SUB_TYPES.OTHER) {
          sum.valueOtherIncome += Number(pa.value) || 0;
        }
      }
    }
  }); // Do Divisions and Totals

  sum.valueIncome = sum.numMonths ? Number(sum.valueIncome + sum.valueCommission + sum.valueOvertime + sum.valueBusiness) / sum.numMonths : sum.valueIncome + sum.valueCommission + sum.valueOvertime + sum.valueBusiness; // For Means

  sum.valueBusinessNetIncome = sum.valueBusinessGross - sum.valueBusinessExpenses;
  sum.valuePropertyNetIncome = sum.valuePropertyGross - sum.valuePropertyExpenses;
  sum.valueAlimonyMaintenance = sum.numMonths ? Number(sum.valueAlimonyMaintenance) / sum.numMonths : Number(sum.valueAlimonyMaintenance) || 0;
  sum.valueContributionsSupport = sum.numMonths ? Number(sum.valueContributionsSupport) / sum.numMonths : Number(sum.valueContributionsSupport) || 0;
  sum.valueInterestDividendsRoyalties = sum.numMonths ? Number(sum.valueInterestDividendsRoyalties) / sum.numMonths : Number(sum.valueInterestDividendsRoyalties) || 0;
  sum.valuePensionRetirement = sum.numMonths ? Number(sum.valuePensionRetirement) / sum.numMonths : Number(sum.valuePensionRetirement) || 0;
  sum.valueUnemployment = sum.numMonths ? Number(sum.valueUnemployment) / sum.numMonths : Number(sum.valueUnemployment) || 0;
  sum.valueSocialSecurity = sum.numMonths ? Number(sum.valueSocialSecurity) / sum.numMonths : Number(sum.valueSocialSecurity) || 0;
  sum.valueOtherIncome = sum.numMonths ? Number(sum.valueOtherIncome) / sum.numMonths : Number(sum.valueOtherIncome) || 0;
  sum.valueTotalMonthlyIncome = sum.valueIncome + sum.valueAlimonyMaintenance + sum.valueContributionsSupport + sum.valueInterestDividendsRoyalties + sum.valuePensionRetirement + sum.valueUnemployment + sum.valueSocialSecurity + sum.valueOtherIncome;
  return sum;
}

function getIncomeSummary(incomes) {
  var _fin;

  var dict = {
    em: {},
    ne: {},
    summary: {
      employed: false,
      valueIncome: 0,
      valueCommission: 0,
      valueOvertime: 0,
      deductions: {},
      nonEmployment: {}
    }
  }; // EMPLOYMENT

  incomes.filter(function (i) {
    return i.type === INCOME_TYPES.EMPLOYMENT && i.disbursements && i.disbursements.length > 0;
  }).forEach(function (i) {
    // Check if a current employment
    if (!i.endedAt || i.endedAt && !isNaN(new Date(i.endedAt))) {
      dict.summary.employed = true;
    } else {
      // If this ended, don't include pay advices
      return;
    } // Tally Pay Advices


    i.disbursements.filter(function (pa) {
      return pa.receivedAt != null;
    }).forEach(function (pa) {
      var bucket = "".concat(new Date(pa.receivedAt).getUTCFullYear(), "-").concat(new Date(pa.receivedAt).getUTCMonth() + 1);

      if (!dict.em[bucket]) {
        dict.em[bucket] = {
          valueIncome: 0,
          valueCommission: 0,
          valueOvertime: 0,
          deductions: {}
        };
      }

      dict.em[bucket].valueIncome += Number(pa.valueIncome) || 0;
      dict.em[bucket].valueCommission += Number(pa.valueCommission) || 0;
      dict.em[bucket].valueOvertime += Number(pa.valueOvertime) || 0;
      Object.keys(pa.deductions).forEach(function (dk) {
        if (!isNaN(pa.deductions[dk])) {
          if (!dict.em[bucket].deductions[dk]) dict.em[bucket].deductions[dk] = 0;
          dict.em[bucket].deductions[dk] += Number(pa.deductions[dk]) || 0;
        } else if (dk === 'others') {
          // Pass over others
          if (!dict.em[bucket].deductions[dk]) dict.em[bucket].deductions[dk] = [];
          dict.em[bucket].deductions[dk] = [].concat(_toConsumableArray(dict.em[bucket].deductions[dk]), _toConsumableArray(pa.deductions[dk]));
        }
      });
    });
  }); // Work backwards until missing employment numbers

  if (dict.summary.employed) {
    var bucketYear = new Date().getUTCFullYear();
    var bucketMonth = new Date().getUTCMonth() + 1;
    var foundBuckets = 0; // Tally up values for each bucket

    var _loop = function _loop(mc) {
      if (!dict.em["".concat(bucketYear, "-").concat(bucketMonth - mc)] && mc === 0) bucketMonth += 1;
      var modifiedBucketMonth = void 0;
      var modifiedBucketYear = void 0;

      if (bucketMonth - mc < 1) {
        modifiedBucketMonth = 12 - (bucketMonth - mc);
        modifiedBucketYear = bucketYear - 1;
      }

      var finalKey = "".concat(modifiedBucketYear || bucketYear, "-").concat(modifiedBucketMonth || bucketMonth - mc);

      if (finalKey && dict.em[finalKey]) {
        foundBuckets += 1;
        dict.summary.valueIncome += Number(dict.em[finalKey].valueIncome) || 0 + Number(dict.em[finalKey].valueCommission) || 0;
        dict.summary.valueOvertime += Number(dict.em[finalKey].valueOvertime) || 0; // Tally up deductions

        Object.keys(dict.em[finalKey].deductions).forEach(function (dk) {
          if (dict.summary.deductions[dk] == null) dict.summary.deductions[dk] = 0;

          if (dk === 'others' && dict.em[finalKey].deductions.otherObligations != null) {
            dict.em[finalKey].deductions.otherObligations.forEach(function (o) {
              dict.summary.deductions[dk] += Number(o.value) || 0;
              dict.summary.otherDeductionNames = "".concat(dict.summary.otherDeductionNames || '').concat(o.name ? "".concat(o.name, ". ") : '');
            });
          } else if (!isNaN(dict.em[finalKey].deductions[dk])) {
            dict.summary.deductions[dk] += Number(dict.em[finalKey].deductions[dk]) || 0;
          }
        }); // If we're past first step, we've reached end of stubs and our summary
      } else if (!dict.em[finalKey] && mc > 0) {
        return "break";
      }
    };

    for (var mc = 0; mc < 6; mc += 1) {
      var _ret = _loop(mc);

      if (_ret === "break") break;
    } // Transfer over top level values with buckets


    Object.keys(dict.summary).forEach(function (sk) {
      if (!isNaN(dict.summary[sk])) dict.summary[sk] = dict.summary[sk] / foundBuckets;
    });
    Object.keys(dict.summary.deductions).forEach(function (sk) {
      if (!isNaN(dict.summary.deductions[sk])) dict.summary.deductions[sk] = dict.summary.deductions[sk] / foundBuckets;
    });
    dict.summary.employed = true;
  } // NON-EMPLOYMENT


  if (!dict.summary.otherContributions) dict.summary.otherContributions = {
    description: '',
    value: 0
  };
  incomes.filter(function (i) {
    return i.type === INCOME_TYPES.NON_EMPLOYMENT && i.disbursements && i.disbursements.length > 0;
  }).forEach(function (i) {
    // Make sure this income is still being received
    if (!i.endedAt || i.endedAt && !isNaN(new Date(i.endedAt)) && new Date(i.endedAt) > new Date()) {
      // Separate out external contributions (for expenses. ex) my X is paying for a phone bill)
      if (i.subType === INCOME_SUB_TYPES.HOUSEHOLD_CONTRIBUTIONS) {
        if (i.additionalDescription) dict.summary.otherContributions.description = "".concat(dict.summary.otherContributions.description).concat(i.additionalDescription ? "".concat(i.additionalDescription, ". ") : ''); // Tally Pay Advices

        dict.summary.otherContributions.value += i.disbursements.filter(function (pa) {
          return pa.receivedAt != null;
        }).reduce(function (accum, pa) {
          return accum += pa.value;
        }, 0);
      } else {
        // Tally Pay Advices
        i.disbursements.filter(function (pa) {
          return pa.receivedAt != null;
        }).forEach(function (pa) {
          var bucket = "".concat(new Date(pa.receivedAt).getUTCFullYear(), "-").concat(new Date(pa.receivedAt).getUTCMonth() + 1);
          if (!dict.ne[_.camelCase(i.subType)]) dict.ne[_.camelCase(i.subType)] = {};
          dict.ne[_.camelCase(i.subType)][bucket] = (Number(dict.ne[_.camelCase(i.subType)][bucket]) || 0) + pa.value;
        }); // TODO: Going to assume for now every month will have a value, even if 0. Not going to try filling things in

        Object.keys(dict.ne).forEach(function (neKey) {
          dict.summary.nonEmployment[neKey] = Object.values(dict.ne[neKey]).reduce(function (a, v) {
            return a += Number(v) || 0;
          }, 0) / Object.keys(dict.ne[neKey]).length;
        });

        if (i.subType === INCOME_SUB_TYPES.OTHER_GOV_ASSISTANCE) {
          dict.summary.otherGovAssistanceNames = "".concat(dict.summary.otherGovAssistanceNames || '').concat(i.otherGovAssistanceName ? "".concat(i.otherGovAssistanceName, ". ") : '');
        } else if (i.subType === INCOME_SUB_TYPES.OTHER) {
          dict.summary.otherIncomeNames = "".concat(dict.summary.otherIncomeNames || '').concat(i.additionalDescription ? "".concat(i.additionalDescription, ". ") : '');
        }
      }
    }
  }); // Extras

  dict.summary.valueGrossIncome = Number(dict.summary.valueIncome) + Number(dict.summary.valueOvertime);
  dict.summary.valueDeductions = Object.values(dict.summary.deductions).reduce(function (a, v) {
    return a += Number(v);
  }, 0);
  dict.summary.valueTakeHomePay = Number(dict.summary.valueIncome) + Number(dict.summary.valueCommission) + Number(dict.summary.valueOvertime) - Number(dict.summary.valueDeductions);
  dict.summary.valueNonEmployment = Object.values(dict.summary.nonEmployment).reduce(function (a, v) {
    return a += Number(v);
  }, 0);
  dict.summary.valueMonthlyIncome = Number(dict.summary.valueTakeHomePay) + Number(dict.summary.valueNonEmployment);
  dict.summary.valueAll = Number(dict.summary.valueTakeHomePay) + Number(dict.summary.valueNonEmployment) + Number(dict.summary.otherContributions ? dict.summary.otherContributions.value : 0);
  dict.summary.valueTaxDeductions = Number(dict.summary.deductions.federalTaxes) + Number(dict.summary.deductions.stateTaxes) + Number(dict.summary.deductions.otherTaxes) + Number(dict.summary.deductions.socialSecurity) + Number(dict.summary.deductions.medicare);
  dict.summary.valueInsuranceDeductions = Number(dict.summary.deductions.medicalInsurance) + Number(dict.summary.deductions.visionInsurance) + Number(dict.summary.deductions.dentalInsurance) + Number(dict.summary.deductions.socialSecurity) + Number(dict.summary.deductions.lifeInsurance);
  var fin = (_fin = {
    current: dict.summary,
    last6Months: calcIncomeSummarySlice(incomes, _dateFns["default"].subMonths(new Date(), 6), new Date())
  }, _defineProperty(_fin, _dateFns["default"].getYear(new Date()), calcIncomeSummarySlice(incomes, _dateFns["default"].startOfYear(new Date()), 'year')), _defineProperty(_fin, _dateFns["default"].getYear(_dateFns["default"].subYears(new Date(), 1)), calcIncomeSummarySlice(incomes, _dateFns["default"].startOfYear(_dateFns["default"].subYears(new Date(), 1)), 'year')), _defineProperty(_fin, _dateFns["default"].getYear(_dateFns["default"].subYears(new Date(), 2)), calcIncomeSummarySlice(incomes, _dateFns["default"].startOfYear(_dateFns["default"].subYears(new Date(), 2)), 'year')), _defineProperty(_fin, "year", calcIncomeSummarySlice(incomes, _dateFns["default"].startOfYear(new Date()), 'year')), _defineProperty(_fin, "yearAgo1", calcIncomeSummarySlice(incomes, _dateFns["default"].startOfYear(_dateFns["default"].subYears(new Date(), 1)), 'year')), _defineProperty(_fin, "yearAgo2", calcIncomeSummarySlice(incomes, _dateFns["default"].startOfYear(_dateFns["default"].subYears(new Date(), 2)), 'year')), _fin);
  return fin;
}

var _default = getIncomeSummary;
exports["default"] = _default;